import { render, staticRenderFns } from "./CallUploader.vue?vue&type=template&id=48e3958b&scoped=true"
import script from "./CallUploader.vue?vue&type=script&lang=js"
export * from "./CallUploader.vue?vue&type=script&lang=js"
import style0 from "./CallUploader.vue?vue&type=style&index=0&id=48e3958b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e3958b",
  null
  
)

export default component.exports